"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var flatpickr_1 = __importDefault(require("flatpickr"));
var de_js_1 = require("flatpickr/dist/l10n/de.js");
var constants_1 = require("../data/constants");
var Flatpickr = /** @class */ (function (_super) {
    __extends(Flatpickr, _super);
    function Flatpickr() {
        var _this = _super.call(this, constants_1.DATA_FLATPICKR) || this;
        if (!_this.getElement())
            return _this;
        _this.flatpickrElements = document.querySelectorAll("[".concat(constants_1.DATA_FLATPICKR_FORM, "]"));
        switch (document.documentElement.lang) {
            case 'en':
                _this.lang = null;
                break;
            case 'de':
                _this.lang = de_js_1.German;
                break;
        }
        _this.createFlatpickr();
        return _this;
    }
    Flatpickr.prototype.createFlatpickr = function () {
        var _this = this;
        this.flatpickrElements.forEach(function (flatpickrEl) {
            var flatpickrInput = flatpickrEl.querySelector("[".concat(constants_1.DATA_FLATPICKR, "]"));
            var inputFrom = flatpickrEl.querySelector("[".concat(constants_1.DATA_FLATPICKR_FROM, "]"));
            var inputTo = flatpickrEl.querySelector("[".concat(constants_1.DATA_FLATPICKR_TO, "]"));
            (0, flatpickr_1.default)(flatpickrInput, {
                locale: _this.lang,
                dateFormat: 'd.m.Y',
                mode: 'range',
                minDate: 'today',
                onClose: function (selectedDates) {
                    var _a, _b;
                    var regExp = /\./g;
                    var fromDate = (_a = selectedDates[0]) === null || _a === void 0 ? void 0 : _a.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(regExp, '-');
                    var toDate = (_b = selectedDates[1]) === null || _b === void 0 ? void 0 : _b.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(regExp, '-');
                    inputFrom.value = fromDate;
                    inputTo.value = toDate;
                },
                onReady: function () {
                    _this.resizeInput(flatpickrInput);
                },
                onChange: function () {
                    _this.resizeInput(flatpickrInput);
                }
            });
        });
    };
    Flatpickr.prototype.resizeInput = function (flatpickrInputEl) {
        // Set input length to its value
        if (flatpickrInputEl.value.length > 0) {
            flatpickrInputEl.setAttribute('size', flatpickrInputEl.value.length.toString());
        }
        // Set input length to its placeholder
        else {
            flatpickrInputEl.setAttribute('size', (flatpickrInputEl.getAttribute('placeholder').length - 1).toString());
        }
    };
    return Flatpickr;
}(AbstractComponent_1.default));
exports.default = Flatpickr;
